<template>
  <div class="datePicker">
    <q-spacer vertical="xs">
      <q-spacer horizontal="sm" style="position: relative">
        <hr class="datePicker__currentBorder-top" />
        <hr class="datePicker__currentBorder-bottom" />
      </q-spacer>
      <q-grid :column="3" class="datePicker__wrapper">
        <div class="datePicker__itemContainer" v-on="handlers">
          <q-text
            v-for="(date, i) in generateDate()"
            :id="`date_${date}`"
            :key="i"
            :ref="`date_${date}`"
            :class="'datePicker__item'"
            variant="ui-baseline"
            >{{ date }}</q-text
          >
        </div>
        <div class="datePicker__itemContainer" v-on="handlers">
          <q-text
            v-for="(month, i) in generateMonth()"
            :key="i"
            :id="`month_${month.index}`"
            :ref="`month_${month.index}`"
            :class="'datePicker__item'"
            variant="ui-baseline"
            >{{ month.value }}</q-text
          >
        </div>
        <div class="datePicker__itemContainer" v-on="handlers">
          <q-text
            v-for="(year, i) in generateYearList()"
            :key="i"
            :id="`year_${year}`"
            :ref="`year_${year}`"
            :class="'datePicker__item'"
            variant="ui-baseline"
            >{{ year }}</q-text
          >
        </div>
      </q-grid>
    </q-spacer>
  </div>
</template>
<script>
import { Spacer as QSpacer, Text as QText, Grid as QGrid } from '@qoala/ui';
import moment from 'moment';

export default {
  name: 'GeneralDatePickerTray',
  components: {
    QSpacer,
    QText,
    QGrid,
    moment
  },
  props: {
    defaultDate: {
      type: String
    },
    updateDate: {
      type: Function
    },
    rangeYear: {
      type: Number
    },
    isDob: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selDate: {
        date: '',
        month: '',
        year: ''
      },
      handlers: {
        scroll: this.handleScroll,
        mousedown: this.handleMouseDown,
        mousemove: this.handleMouseMove,
        mouseleave: this.handleMouseLeave,
        mouseup: this.handleMouseUp,
        touchmove: this.handleMouseMove,
        touchend: this.handleMouseLeave,
        click: this.handleClick
      },
      isDown: false,
      startY: 0
    };
  },
  watch: {
    defaultDate(val) {
      const currDate = moment(val);
      this.selDate.date = parseInt(currDate.format('D'));
      this.selDate.month = parseInt(currDate.format('MM'));
      this.selDate.year = parseInt(currDate.format('YYYY'));
      this.initDate();
    }
  },
  mounted() {
    const currDate = moment(this.defaultDate);
    this.selDate.date = parseInt(currDate.format('D'));
    this.selDate.month = parseInt(currDate.format('MM'));
    this.selDate.year = parseInt(currDate.format('YYYY'));
    this.generateDate();
    this.generateMonth();
    this.initDate();
  },
  methods: {
    handleMouseDown(e) {
      this.isDown = true;
      this.startY = e.pageY - e.target.offsetTop;
      this.scrollTop = e.target.scrollTop;
    },
    handleClick(e) {
      e.srcElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    handleMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const Y = e.pageY - e.target.offsetParent.offsetTop;
      const walk = Y - this.startY;
      e.target.offsetParent.scrollTop = this.scrollTop - walk;
    },
    handleMouseLeave() {
      this.isDown = false;
    },
    handleMouseUp() {
      this.isDown = false;
    },
    handleTouch(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    generateMonth() {
      const months = [];
      const dateStart = moment('2020-01-01');
      const dateEnd = moment(dateStart).add(11, 'month');
      while (dateEnd.diff(dateStart, 'months') >= 0) {
        months.push({ index: dateStart.format('M'), value: dateStart.format('MMMM') });
        dateStart.add(1, 'month');
      }
      return months;
    },
    generateDate() {
      let monthIndex = this.selDate.month - 1;
      let date = new Date(this.selDate.year, monthIndex, 1);
      let days = [];
      while (date.getMonth() === monthIndex) {
        days.push(date.getDate());
        date.setDate(date.getDate() + 1);
      }
      return days;
    },
    setRef(ref) {
      const elOffset = ref[0].$el.offsetTop;
      ref[0].$el.offsetParent.scrollTop = elOffset - 30;
    },
    initDate() {
      this.generateYearList();
      const containers = document.getElementsByClassName('datePicker__itemContainer') || [];
      this.$nextTick(() => {
        const yearRef = this.$refs[`year_${parseInt(this.selDate.year)}`];
        const monthRef = this.$refs[`month_${parseInt(this.selDate.month)}`];
        const dateRef = this.$refs[`date_${parseInt(this.selDate.date)}`];

        if (containers.length > 2) {
          if (yearRef.length !== 0) this.setRef(yearRef);
          if (monthRef.length !== 0) this.setRef(monthRef);
          if (dateRef.length !== 0) this.setRef(dateRef);
        }
      });
    },
    generateYearList() {
      const startYear = new Date().getFullYear() - this.rangeYear - 1;
      const rangeYear = this.rangeYear;
      const rangeYearArr = [startYear];
      Array.from(Array(rangeYear).keys()).map(item => {
        rangeYearArr.push(startYear + item + 1);
      });
      return rangeYearArr;
    },
    updateParentDate() {
      const { date, month, year } = this.selDate;
      let selDate = `${year}-${month}-${date}`;
      selDate = this.$moment(selDate, 'YYYY-M-D').format('YYYY-MM-DD');
      if (this.isDob) {
        const result = {
          date: selDate,
          age: this.$moment().diff(selDate, 'years')
        };
        return this.$emit('updateDate', result);
      } else {
        return this.$emit('updateDate', selDate);
      }
    },
    setCurrenteDate(item) {
      if (item.id) {
        item.classList.add('active');
        if (item.id.includes('date')) {
          this.selDate.date = item.innerHTML;
        } else if (item.id.includes('month')) {
          this.selDate.month = item.id.split('_')[1];
        } else if (item.id.includes('year')) {
          this.selDate.year = item.id.split('_')[1];
        }
        this.updateParentDate();
        this.$forceUpdate();
      }
    },
    unsetDate(item) {
      if (item.id) {
        item.classList.remove('active');
      }
    },
    checkInView(elem, container) {
      if (elem.id) {
        let contHeight = container.offsetHeight;
        let elemTop = elem.getBoundingClientRect().top - container.getBoundingClientRect().top;
        let elemBottom = elemTop + elem.offsetHeight;
        let isViewed = elemTop >= 0 && elemBottom <= contHeight && elemBottom > 60;
        return isViewed;
      }
    },
    handleScroll(event) {
      const children = event.target.childNodes;
      for (let i = 0; i < children.length; i++) {
        if (this.checkInView(children[i], event.target)) {
          this.setCurrenteDate(children[i]);
        } else {
          this.unsetDate(children[i]);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin borderDivider {
  border-top: 0.5px solid #95989a;
  opacity: 0.09;
  margin: 0 !important;
  height: 1px;
  position: absolute;
  right: 0;
  left: 0;
}

.datePicker {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &__wrapper {
    height: 100px;
    grid-template-columns: 30% 40% 30%;
    text-align: center;
  }
  &__itemContainer {
    cursor: grab;
    scrollbar-width: none;
    scroll-behavior: smooth;
    position: relative;
    overflow-y: scroll;
    scroll-snap-points-y: repeat(0.1rem);
    scroll-snap-type: y mandatory;
    scroll-snap-type: mandatory;
    scroll-snap-destination: 0 0;
    padding-bottom: 28px;
    padding-top: 35px;
  }
  &__item {
    scroll-snap-align: center;
    line-height: 3;
    color: rgb(186, 188, 190);
    font-weight: normal;
    &.active {
      color: #1253a4;
      font-weight: bold;
    }
  }
  &__currentBorder {
    &-top {
      @include borderDivider;
      top: 32px;
    }
    &-bottom {
      @include borderDivider;
      top: 70px;
    }
  }
}
</style>
